import { Base } from '@gate31/core/src/libs/BaseComponent';
import { ReviewsApi } from '@gate31/core/src/api/MneniyaApi';
import { InsalesProduct } from '@gate31/feature/InsalesProduct/InsalesProduct';
import { Stats, Review } from '@gate31/types/ReviewsTypes';
import { ProductReviewsHeaderDesk } from '@gate31/desktop/components/ProductReviewsHeaderDesk/ProductReviewsHeaderDesk';
import { ProductReviewsItemsDesk } from '@gate31/desktop/components/ProductReviewsItemsDesk/ProductReviewsItemsDesk';
import { ProductReviewsFormDesk } from '@gate31/desktop/components/ProductReviewsFormDesk/ProductReviewsFormDesk';
import Client from '@gate31/uikit/common/components/client/client';
import { faro } from '@gate31/faro/src';

interface ReviewsOptions {
    product: InsalesProduct;
}

export class ProductReviewsDesk extends Base<HTMLElement> {
    static cn = new Base.BuildCn('ProductReviewsDesk');

    api = new ReviewsApi();
    product: InsalesProduct;
    productReviewsHeader: ProductReviewsHeaderDesk;
    productReviewsItems: ProductReviewsItemsDesk;
    productReviewsForm: ProductReviewsFormDesk;
    reviewsStat: Stats;
    reviewsList: Review[];

    constructor(node: HTMLElement, options: ReviewsOptions) {
        super(node);

        this.product = options.product;
        this.productReviewsHeader = new ProductReviewsHeaderDesk(ProductReviewsHeaderDesk.querySelector(ProductReviewsHeaderDesk.cn.toSelector()));
        this.productReviewsItems = new ProductReviewsItemsDesk({
            container: ProductReviewsDesk.querySelector(ProductReviewsDesk.cn.setElem('wrap').toSelector()),
            template: 'reviews-item-desk-template'
        });

        Client.get()
            .then(() => {
                this.productReviewsForm = new ProductReviewsFormDesk(
                    ProductReviewsFormDesk.querySelector<HTMLFormElement>(ProductReviewsFormDesk.cn.toSelector()), { product: this.product }
                );
            })
            .catch(() => {});

        this.connectionCallback();
    }

    getReviews(): Promise<Array<Review[]> | []> {
        return this.api.getReviewsProduct(this.product.id)
            .then(res => {
                this.reviewsStat = res.Stats;
                this.reviewsList = res.Reviews;

                return res.Reviews;
            })
            .catch(err => {
                faro.api.pushError(err, {
                    context: {
                        section: `Error ger review - ${err}`
                    }
                });
            });
    }

    connectionCallback() {
        this.getReviews()
            .then(() => {
                // ** Информациф об отзывах получена **
                this.productReviewsHeader.render({
                    template: 'reviews-rating-desk-template',
                    reviewsStat: this.reviewsStat
                });
                this.productReviewsItems.render({
                    reviewsStat: this.reviewsStat,
                    reviewsList: this.reviewsList
                });
            });
    }
}
